/**
 * A reusable template (шаблон), backed by the `/v2/package-templates` API — a coverage template snapshots
 * a whole content (pricing + options); an option template snapshots a single option (with its sub-options).
 * The list/header shape (`PackageTemplate`) never carries the snapshot itself: applying a template calls a
 * dedicated backend endpoint that reconstructs it server-side, so the front end only ever needs the id.
 */
export enum PackageTemplateKind {
  Coverage = 'Coverage',
  Option = 'Option',
}

export interface PackageTemplate {
  id: string;
  kind: PackageTemplateKind;
  name: string;
  description?: string;
  createdAt: string;
}
